/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable no-else-return */
/* eslint-disable prefer-template */
/* eslint-disable prettier/prettier */
import { getCookie } from './cookies';

export default function authHeader() {
  var token = getCookie('ewangelibus_user');

  if (token !== '') {
    return { Authorization: 'Bearer ' + token };
  } else {
    return {};
  }
}
